<template>
  <div class="mainbody" style="margin-top: -4rem;">
    <div class="modules0 modules00" style="text-align: center;" v-scroll-animate="'slide-itemgk'">
              <div class="title-with-lines">
                <div class="clipped-gradient-line0510 clipped-gradient-line10510"></div>
                <span class="title-text"><span>公司简介</span></span>
                <div class="clipped-gradient-line0510"></div>
              </div>
              <div class="grayTxt bounce-element1"> COMPANY PROFILE</div>
    </div>
     <div class="whiteBg" > 
        <div class="txtMd2"  v-scroll-animate="'fly-in-bottom'">
           <div> 
           <p>            
            河南中浩信息科技有限公司是从事科技业务的国有企业，注册资本1000万，主要从事信息系统开发及维护、机电及特种设备维保等业务。
          </p>
          <p>            
            公司秉承“精惠取胜、诚信至上”的经营理念，与“踏实务实、开拓创新、和谐高效、追求卓越”的管理理念，
            赢得客户广泛认可，承接并相继完成了“郑欧班列订舱系统GPS定位系统、跨境电子商务平台、中欧多式联运综合服务信息平台”等省重点工程的配套项目。
          </p>
          <p>            
            公司开发方向涵盖市面上的热门语言，例如JAVA,NET，以及移动开发Android和I0S等，同时公司拥有自动控制和机械电气控制方面的新兴科技人才。
          </p>
          <p>            
            公司愿同广大客户一道，凭借研发能力强、管理严谨科学的团队抢抓互联网时代的历史机遇，精诚合作，共赢未来。
          </p>
           </div>
         
        </div>
     
        <div class="rowImg0510 rowImg05101" v-scroll-animate="'fly-in-left5'" >
        </div>
    </div>
    <div class="twoImg"> 
      <div class="imgDiv" >
        <img src="../../assets/ywbkNew/zhonghaoNew/1.png" v-scroll-animate="'duijiaoAnimate'" />
      </div>
      <div class="imgDiv" >
        <img src="../../assets/ywbkNew/zhonghaoNew/2.png" v-scroll-animate="'duijiaoAnimate1'" />
      </div>
    </div>

    <div class="modules0 modules00" style="text-align: center;" v-scroll-animate="'slide-itemgk'">
              <div class="title-with-lines">
                <div class="clipped-gradient-line0510 clipped-gradient-line10510"></div>
                <span class="title-text"><span>资质证书</span></span>
                <div class="clipped-gradient-line0510"></div>
              </div>
              <div class="grayTxt bounce-element1"> HONOR AND QUALIFICATION</div>
    </div>
    <div class="zizhizhengshuTxt" v-scroll-animate="'fly-in-left5'"> 
      中浩科技目前拥有软著58项、专利3项、商标15项、科学技术成果证书4项，获得S09001(质量管理)/14001(环境管理)/27001(信息安全管理)体系认证证书。具备安许证、特种设备生产许可证、食品经营许可证、电子与智能化工程专业承包贰级等资质，是一家综合性发展的信息化公司。
    </div>
    <div class="zizhiImg" v-scroll-animate="'fly-in-right5'"> 
     <img src="../../assets/ywbkNew/zhonghao/zhzizhi.png" />
    </div>

    <div class="modules0 modules00" style="text-align: center;" v-scroll-animate="'slide-itemgk'">
              <div class="title-with-lines">
                <div class="clipped-gradient-line0510 clipped-gradient-line10510"></div>
                <span class="title-text"><span>解决方案</span></span>
                <div class="clipped-gradient-line0510"></div>
              </div>
              <div class="grayTxt bounce-element1"> SOLUTION</div>
              <div class="otherJiejuefangantitle"> 
                科技改变生活，智能引领未来
              </div>
    </div>
    <div class="txtAndImg"> 
      <div class="txtDiv" v-scroll-animate="'fly-in-left5'"> 
        <h1>数字班列平台</h1>
        <p> 
          数字化班列平台实现了“一平台”，“两端””N支撑“。“两端”即客户端、平台端，”N支撑“即各操作子系统(含集装箱管理系统，单证系统，公路系统，场站系统，堆场系统等)。2016年在全国率先上线服务班列业务的订舱综合服务平台，为全国中欧班列数字化应用发挥了示范引领作用。目前，中欧班列(郑州)全部实现线上订舱。
        </p>
      </div>
      <div class="imgDiv" v-scroll-animate="'fly-in-right5'"> 
        <img src="../../assets/ywbkNew/zhonghao/shuzi.png" />
      </div>
    </div>
    <div class="txtAndImg txtAndImgOtherColor"> 
      <div class="txtDiv" v-scroll-animate="'fly-in-left5'"> 
        <h1>冷链综合服务信息平台</h1>
        <p> 
          依托冷链温控系统打造“数字冷链班列”，中欧班列（郑州）冷链物流已成为服务“一带一路”沿线国家贸 易的特色品牌业务。
        </p>
      </div>
      <div class="imgDiv" v-scroll-animate="'fly-in-right5'"> 
        <img src="../../assets/ywbkNew/zhonghao/lenglian.png" />
      </div>
    </div>
    <div class="txtAndImg"> 
      <div class="txtDiv" v-scroll-animate="'fly-in-left5'"> 
        <h1>数字化供应链</h1>
        <p> 
          采用“货-箱-单”相集成信息单元，以集装箱共享中心为核心，实现货物随集装箱的集疏、分拨、流转、储存、发送、转运、接收的全流程一体化管控。包括现场管控，多式联运的转接、发运，提供端到端、门到门的“一单制”服务。推动物流服务社会化、信息化、专业化发展，提高郑州国际物流枢纽在国家战略层面的地位。
        </p>
      </div>
      <div class="imgDiv" v-scroll-animate="'fly-in-right5'"> 
        <img src="../../assets/ywbkNew/20250812.jpg" />
      </div>
    </div>

    <div class="modules0 modules00" style="text-align: center;" v-scroll-animate="'slide-itemgk'">
              <div class="title-with-lines">
                <div class="clipped-gradient-line0510 clipped-gradient-line10510"></div>
                <span class="title-text"><span>数字班列赋能</span></span>
                <div class="clipped-gradient-line0510"></div>
              </div>
              <!-- <div class="grayTxt bounce-element1"> SOLUTION</div> -->
              <div class="otherJiejuefangantitle"> 
                科技创新，数字赋能
              </div>
              <div class="otherJiejuefangantitle fontsizeChangecss0"> 
               业务系统与数据赋能 
              </div>
              
    </div>
    <div class="blFuneng" v-scroll-animate="'fly-in-bottom'"> 
      <div class="funengItem" >
        <ul> 
          <li class="imgLi"> 
            <img src="../../assets/ywbkNew/zhonghao/jianghuha.png" />
          </li>
          <li class="titleLi"> 
            强化平台运行保障筑牢发展根基
          </li>
          <li class="txtLi"> 
            通过全天候运维监测与快速响应机制，平台全年无故障运行率达98%以上，支撑日均询价、订舱、单证估算等超2万条班列开行业务数据操作
          </li>
         
        </ul>
      </div>
      <div class="funengItem">
        <ul> 
          <li class="imgLi"> 
            <img src="../../assets/ywbkNew/zhonghao/youhua.png" />
          </li>
          <li class="titleLi">  
            优化客户服务体验增强市场竞争力
          </li>
          <li class="txtLi"> 
            打通订舱、场站，报关，单证，物流追综等20余个环节，优化业务操作流程，客户线上操作效率提升60%，异常问题30分钟内响应，提升客户满意度。
          </li>
         
        </ul>
      </div>
      <div class="funengItem">
        <ul> 
          <li class="imgLi"> 
            <img src="../../assets/ywbkNew/zhonghao/senhua.png" />
          </li>
          <li class="titleLi">  
            深化数据应用赋能业务决策
          </li>
          <li class="txtLi"> 
            建成班列运行数据库，包括班列信息、询价信息、订舱信息、集装箱信息、物流信息、结算信息等关键指标为日常各类数据统计分析及后续数据中台建设、大数据分析提供数据支撑。
          </li>
         
        </ul>
      </div>
    </div>

    <div class="modules0 modules00" style="text-align: center;" v-scroll-animate="'slide-itemgk'">
        <div class="otherJiejuefangantitle fontsizeChangecss0"> 
          智能化装置与系统赋能 
        </div>
    </div>
    <div class="blFuneng marginBottom1rem" v-scroll-animate="'fly-in-bottom'"> 
      <div class="funengItem noPaddingcss0">
        <ul> 
          <li class="whitetitleLi bgIMg1"> 
            三维物体尺寸测量及智能装箱系统
          </li>
        </ul>
      </div>
      <div class="funengItem noPaddingcss0">
        <ul> 
          <li class="whitetitleLi bgIMg2"> 
            冷藏箱新风远程控制系统
          </li>
        </ul>
      </div>
      <div class="funengItem noPaddingcss0">
        <ul> 
          <li class="whitetitleLi bgIMg3"> 
            适冷适运实验室
          </li>
        </ul>
      </div>
    </div>
    <div class="blFuneng" v-scroll-animate="'fly-in-bottom'"> 
      <div class="funengItem noPaddingcss0">
        <ul> 
          <li class="whitetitleLi bgIMg4"> 
            基于太阳能的集装箱新型全球定位系统
          </li>
        </ul>
      </div>
      <div class="funengItem noPaddingcss0">
        <ul> 
          <li class="whitetitleLi bgIMg5"> 
            集装箱全生命周期管理系统
          </li>
        </ul>
      </div>
      <div class="funengItem noPaddingcss0">
        <ul> 
          <li class="whitetitleLi bgIMg6"> 
            集装箱运输汽车柔性支架
          </li>
        </ul>
      </div>
    </div>

    <div class="modules0 modules00" style="text-align: center;" v-scroll-animate="'slide-itemgk'">
              <div class="title-with-lines">
                <div class="clipped-gradient-line0510 clipped-gradient-line10510"></div>
                <span class="title-text"><span>联系我们</span></span>
                <div class="clipped-gradient-line0510"></div>
              </div>
              <div class="grayTxt bounce-element1">CONTACT US</div>
    </div>
    <div class="txtAndImg divBgImg0" v-scroll-animate="'fly-in-bottom'"> 
      <div class="txtDiv"> 
        <h1>做最受客户信赖的企业</h1>
       

        <p> 
          联系人:李女士 13027701968
        </p>
        <p> 
          电话:0371-55172380
        </p>
         <p> 
          <!-- 邮箱:lgkj@zih718.com -->
          邮箱:zhkj@zygangwu.com
        </p>
        <p>
          网址:WWW.ZHONGHAOKEJI.CN 
        </p>
        <p>
          地址:郑州市经开区经北四路与十八大街交叉口郑州国际陆港园区B座5层
        </p>
      </div>
      <div class="imgDiverweima"> 
        <img src="../../assets/ywbkNew/zhonghao/zerweima.png" />
        <div> 官方服务号</div>
      </div>
    </div>

    

     
     
   </div>
</template>

<script>
import API from '@/api/bsInfo'

import timeLine from '@/components/businessDetail/timeLine.vue'

export default {
 components: {
  timeLine
 },
 data() {
   return {
    urlBase: process.env.VUE_APP_BASE_API,

    brief:{},
    synopsisList:[],
    zhongouData:{},
   indexNum:null,
   indexNum1:null,
   imgData:[],
   datalist1:[
    {
      name:'国际货运代理服务'
    },
    {
      name:'多式联运运营服务'
    },
    {
      name:'国外物流业务服务'
    },
    {
      name:'物流技术装备服务'
    }
   ],
   datalist2:[
    {
      name:'供应链综合服务'
    },
    {
      name:'仓储配送一体化服务'
    },
    {
      name:'冷链物流服务'
    }
   ],
   
   }
 },
 props: {
   
 },
 mounted() {
     this.zhongoubanlieData();
   },
 methods: {
  getPlainText(htmlString) {
      const tempDiv = document.createElement('div')
      tempDiv.innerHTML = htmlString
      return tempDiv.textContent || tempDiv.innerText || ''
    },
   //获取中欧班列页面数据
   async zhongoubanlieData() {
      try {
        let objParams={
          catId:'f1c0af20344a413fb35498338645dccb'
        }
        const res = await API.zhongoubanlieData(objParams)
        
        this.$nextTick(()=>{
          this.zhongouData = res.data
          this.brief=res.data.brief
          this.brief['content1']=this.getPlainText(this.brief.content)
          this.imgData=(this.brief.photo.split('|')).splice(1,4);
          this.synopsisList=res.data.synopsisList
          console.log('获取成功', res.data.resultData)
        })
       
      } catch (error) {
        console.error('获取失败', error)
      }
    },
  loadMore() {
    let length0=this.timelineItems.length
    let lengthNum=lengthNum0+5
       this.timelineItems=this.timelineItems0.sclice(0,lengthNum)
    }
 },
}
</script>

<style lang="scss" scoped>

 .mainbody{
   width: 100%
   // background: #dde8f4;
   // margin-block: 100px;
   // background:url('../../assets/img3/gaikuang1/chanyepng.png');
 // background-size: 100% 100%;
 // .modules0{
 // 	width: 100%;
 // 	margin: 0 auto;
 // }
    
 }
 .containerDiv{
 width: 100%;
   // background: #dde8f4;
   // margin-block: 100px;
  //  background:url('../../assets/img3/gaikuang1/chanyepng.png');
//  background-size: 100% 100%;
 @media screen and (max-width: 768px) {
   background-size: auto 100%;
 }
 }
 
 .whiteBg{
   width: 90vw;
   margin:0 auto;
  //  margin-bottom:1rem;
  //  height: 13.5rem;
  //  margin-bottom: 5rem;
  //  padding:2rem 0;
   background:url('../../assets/ywbkNew/zhonghao/zhjianjie.png');
    background-size: cover;
      /* 台式机 (可能更大或比例不同) */
   @media screen and (min-width: 1920px),
    screen and (min-width: 1600px) and (min-aspect-ratio: 16/10) {
      // height: 12.5rem;
   }
  //  background:linear-gradient(to bottom, rgba(252, 253, 253, 0), rgb(251, 252, 252,0.8))
  .txtMd2{
    width: 90vw;
    
    margin:0 auto;
    padding:3rem 2rem;
    
    color: #ffffff;
    
     /* 重置所有子元素 */
    & * {
      all: initial;
      font-family: inherit;
      font-size: inherit;
      color: inherit;

     
      text-indent:2rem;
      text-align: justify;
      line-height: 2rem;
    }
    
    
    
      // background-color: rgba(30, 30, 126, 0.5);  
    @media screen and (max-width: 768px) {
      width: 100%;
      margin-left:0;
      line-height: 2rem;
      padding: 3rem;
    }
    
  }

  .txtMd2 ::v-deep(*) {
    font-size: 1.0rem;
    line-height: 2rem;
  }
  .txtMd2 ::v-deep(p) {
     width: 100%;
     display: block;

    //  background: red;
  }
 } 
 .modules3Container{


  position: relative;
  width: 100%;
  .modules3Item{
 
  color: #333333;
 }

 }
 .modules3Container1{
  // width: 100%;
  // background:url('../../assets/ywbkNew/1/7.png');
  // background-size: cover;
  // min-height: 50vw;
  margin-top: 2rem;
  position: relative;
  width: 100%;
  padding-bottom: 6.25%; /* 16:9 比例 (9/16=0.5625) */
  background:url('../../assets/ywbkNew/0/bg2.png');
  background-size: cover;
  background-position: center;

 }
 .modules3Div{
   width: 90vw;
   margin:0 auto;
   padding:2rem 0;
 }
 .modules3Item{
  background: none;
  border: 1px solid #a3c9fa;
  color: #ffffff;
  padding: 4rem 0;
 }
 .modules3rowDiv{
  // padding-top:3rem;
 }
 .activeYwbkItem2{
  // background-color: rgba(249, 249, 251, 0.5);  
  background: #015293;

  
   .titleModule3item{
    font-size: 1.2rem;
    font-weight: bold;
    color: #ffffff;
   }
   li{
   img{
    filter: brightness(0) invert(1); /* 将图片变为白色 */
   }
   }
 }
 .modules3Div1{
  width: 100%;
  padding-left: 5%;
  color: #ffffff;
  // background: #ffffff;
  h5{
    font-size: 1.2rem;
    padding:2rem 0;
  }
  p{
    font-size: 1rem;
    line-height: 2rem;
  }
 }
 
 .el-timeline-item__tail{
  left:50%;
 }
 ::v-deep .el-timeline-item__node--normal{
  left: 50% !important;
  transform: translateX(-1.2rem);
 }
 .modules00 {
    padding:2rem 0;
}
.modules00 *{
  color: #015293 !important;
  .title-text{
    padding: 0 10px;
    font-size: 1.2rem;
    color: #ffffff;
    white-space: nowrap;
    span{
      font-size: 1.4rem;
    }
  }
 



.clipped-gradient-line0510 {
    display: inline-block;
    width: 10vw;
    height: 0.2rem;
    transform: translateY(-0.5rem);
    background: linear-gradient(to right,
            #015293,
            #337ab4,
            #cbdfee,
            #fafafb00);
}

@media screen and (max-width: 768px) {
    .clipped-gradient-line0510  {
        width: 2vw; 
        // 右侧
    }
    
}

.clipped-gradient-line10510 {
    transform: translateY(-0.5rem);
    display: inline-block;
    width: 10vw;
    height: 0.2rem;
    background: linear-gradient(to right,
            #fafafb00,
            #cbdfee,
            #337ab4,
            #015293);
}

 }
 .modules00Blue *{
  color: #015293 !important;
  
}
 @media screen and (max-width: 768px) {
    
    .clipped-gradient-line10510 {
      width: 2vw;
       // 左侧
    }
}
.grayTxt{
  font-weight: bold;
  font-size: 1.5rem;
  padding-top: 0.5rem;
  color: #eee !important;
}
.zizhizhengshuTxt{
  width: 90vw;
  margin:0 auto !important;
  text-indent: 2rem !important;
  line-height: 2rem;
}
.zizhiImg{
  width: 90vw;
  margin:0 auto !important;
  text-align: center;
  img{
    width: 80%;
  }
}
.otherJiejuefangantitle{
  width: 90vw;
  margin:0 auto !important;
  text-align: center;
  color:#333 !important;
  font-size: 0.9rem;
  padding-top: 0.5rem;
}
.fontsizeChangecss0{
  font-size: 1.1rem;
  font-weight: bold;
  line-height: 4rem;
  color: #000 !important;
}
.txtAndImg{
  width: 90vw;
  padding: 1rem;
  margin: 0 auto;
  background: #3E80B8;
  display: flex;
  color: #fff;
  @media screen and (max-width: 768px) {
            flex-direction: column;
  }
  div{
    // flex: 1;
  }
  .txtDiv{
    flex: 1;

    padding:1rem;
   h1{
    font-size: 1.5rem;
    height: 3rem;
    line-height: 3rem;
    text-indent: 2rem;
   }
   p{
    line-height: 2rem;
    text-indent: 2rem;

   }
  }
  .imgDiv{
    width: 30rem;
     @media screen and (max-width: 768px) {
          width: 100%;
  }
     img{
      width: 100%;
     }
  }
  .imgDiverweima{
    width: 30rem;
    text-align: center;
     img{
      width: 10rem;
     }
  }
}
.divBgImg0{
  background: url(../../assets/ywbkNew/zhonghao/zlainxi.png) no-repeat;
  background-size: 100% 100%;
  padding:3rem 5rem;
  margin-bottom: 2rem;
    @media screen and (max-width: 768px) {
          padding:3rem 0;
  }
  div.txtDiv{
    h1{
      height: 5rem;
      line-height: 3rem;
    }
    p{

    }
  }

}
.txtAndImgOtherColor{
  background: #dbecf9;
  color: #333;
  
}
.txtAndImgOtherColor1{
  background: #3b8fcf;
  color: #333;
  
}
.blFuneng{
  width: 90vw;
  margin:0 auto;
  display: flex;
  gap: 1rem;
  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
  .funengItem{
    padding:2rem;
    background: linear-gradient(to bottom, #F0F9FF, #9FDCDB);
    width: 100%;
    text-align: center;
    ul{
      @media screen and (max-width: 768px) {
       height: 100%;
     }
      li{
        list-style: none;
        text-align: center;
        line-height: 2rem;
       
      }
      li.imgLi{
        padding-top: 3rem;
        padding-bottom: 3rem;
       img{
        width: 3.5rem;
       }
      }
      li.titleLi{
        font-weight: bold;
        color:#333;
      }
      li.txtLi{
        text-align:justify;
        text-indent: 2rem;
      }
      li.whitetitleLi{
        color: #fff;
        font-size: 1.1rem;
        @media screen and (max-width: 768px) {
          height: 100%;
        }
      }
     
    }
  }
  .noPaddingcss0{
    padding:0;
    ul{
      li{
        padding:2rem;
      }
      li.bgIMg1{
      background: url(../../assets/ywbkNew/zhonghao/zihneng-1.png)no-repeat;
      background-size: 100% 100%;
      }
      li.bgIMg2{
      background: url(../../assets/ywbkNew/zhonghao/zihneng-2.png) no-repeat;
      background-size: 100% 100%;
      }
      li.bgIMg3{
      background: url(../../assets/ywbkNew/zhonghao/zihneng-3.png) no-repeat;
      background-size: 100% 100%;
      }
      li.bgIMg4{
      background: url(../../assets/ywbkNew/zhonghao/zihneng-4.png) no-repeat;
      background-size: 100% 100%;
      }
      li.bgIMg5{
      background: url(../../assets/ywbkNew/zhonghao/zihneng-5.png) no-repeat;
      background-size: 100% 100%;
      }
      li.bgIMg6{
      background: url(../../assets/ywbkNew/zhonghao/zihneng-6.png) no-repeat;
      background-size: 100% 100%;
      }
    }
  }
}
.marginBottom1rem{
  margin-bottom: 1.5rem;
}
.twoImg{
  padding-top: 1rem;
  width: 90vw;
  margin:0 auto;
  display: flex;
  gap:1rem;
   @media screen and (max-width: 768px) {
   flex-direction: column;
   }
  div.imgDiv{
    flex: 1;
    display: block;
  }
}


.modern-ellipsis1 {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 12;

    /* 台式机 (可能更大或比例不同) */
    @media screen and (min-width: 1920px),
    screen and (min-width: 1600px) and (min-aspect-ratio: 16/10) {
        -webkit-line-clamp: 12;
    }

    overflow: hidden;
    text-overflow: ellipsis;

    /* 处理内部元素 */
    >* {
        display: inline;
        /* 强制内联显示 */
        white-space: normal;
    }
}
 </style>